import { render, staticRenderFns } from "./MappingSaveModal.vue?vue&type=template&id=f23df2fc&scoped=true"
import script from "./MappingSaveModal.vue?vue&type=script&lang=js"
export * from "./MappingSaveModal.vue?vue&type=script&lang=js"
import style0 from "./MappingSaveModal.vue?vue&type=style&index=0&id=f23df2fc&prod&scoped=true&lang=scss"
import style1 from "./MappingSaveModal.vue?vue&type=style&index=1&id=f23df2fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23df2fc",
  null
  
)

export default component.exports